import { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';

import TwoFAForm from './TwoFAForm';
import { Image } from '../AbstractElements';

const TwoFA = () => {
  return (
    <Fragment>
      <section>
        <Container fluid={true}>
        
          <Row>
            
            <Col xl='7' className='b-center bg-size' style={{ backgroundImage: `url(${require('../assets/images/qr-scan.png')})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'block' }}>
              <Image attrImage={{ className: 'bg-img-cover bg-center d-none', src: `${require('../assets/images/qr-scan.png')}`, alt: 'looginpage' }} />
            </Col>
            <Col xl='5 p-0'>
              <TwoFAForm logoClassMain='text-start' />
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default TwoFA;
